var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23534 8.92938C5.5079 8.96433 5.79338 8.98199 6.08144 8.99091C6.38033 10.7894 7.47917 12.3176 9 13.1973V16H7C6.44772 16 6 16.4477 6 17V20H4V22H20V20H18V17C18 16.4477 17.5523 16 17 16H15V13.1973C16.5208 12.3176 17.6197 10.7894 17.9186 8.99091C18.2066 8.98199 18.4921 8.96433 18.7647 8.92938C19.3375 8.85594 19.9447 8.69701 20.4812 8.31373C21.6027 7.51266 22 6.05937 22 4C22 3.44772 21.5523 3 21 3H17.7324C17.3866 2.4022 16.7403 2 16 2H8C7.25972 2 6.61337 2.4022 6.26756 3H3C2.44772 3 2 3.44772 2 4C2 6.05937 2.39726 7.51266 3.51876 8.31373C4.05535 8.69701 4.66251 8.85594 5.23534 8.92938ZM4.04358 5H6V6.98665C5.81701 6.97867 5.64816 6.96594 5.48966 6.94562C5.08749 6.89406 4.84465 6.80299 4.68124 6.68627C4.45809 6.52687 4.15516 6.14418 4.04358 5ZM18 5V6.98665C18.183 6.97867 18.3518 6.96594 18.5103 6.94562C18.9125 6.89406 19.1553 6.80299 19.3188 6.68627C19.5419 6.52687 19.8448 6.14418 19.9564 5H18ZM8 18V20H16V18H8ZM11 16V13.917C11.3252 13.9716 11.6593 14 12 14C12.3407 14 12.6748 13.9716 13 13.917V16H11ZM8 6H16V4H8V6ZM8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8H8Z",
    fill: "#A5ACBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.e0702ef2e501146ed03bac3b04132066.svg";
export { ForwardRef as ReactComponent };